export const ROUTES = {
  HOME: '/',
  LOGIN: '/login',
  SIGNUP: '/signup',
  VERIFY_EMAIL: '/verify-email',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  DATA_DELETION: '/data-deletion',
  AUTH_CALLBACK: '/auth/callback',
  ORGANIZATION_SETUP: '/organization-setup',
  CONNECT_PLATFORMS: '/connect-platforms',
  DASHBOARD: '/dashboard',
  NOTIFICATIONS: '/notifications',
  SUPPORT: '/support',
  STRATEGIES: '/strategies',
  STRATEGY_DETAIL: '/strategies/$strategyId',
  STRATEGY_CAMPAIGN_DETAIL: '/strategies/$strategyId/campaigns/$campaignId',
  ASSETS: '/assets',
  GOALS: '/goals',
  GOAL_DETAIL: '/goals/$goalId',
  AUDIENCES: '/audiences',
  AUDIENCE_DETAIL: '/audiences/$audienceId',
  REPORTS: '/reports',
  INSIGHTS: '/insights',
  AI_PERFORMANCE: '/ai-performance',
  WIZARD_BRIEF: '/wizard/brief',
  PAYWALL: '/paywall',
  SETTINGS: '/settings',
  SETTINGS_BILLING: '/settings/billing',
  CONNECTORS: '/connectors',
  BILLING_RETURN: '/billing/return',
  EXTEND_TRIAL: '/extend-trial',
  AGENCY_PORTFOLIO: '/agency',
  AGENCY_CLIENTS: '/agency/clients',
  AGENCY_TEAM: '/agency/team',
  AGENCY_CONNECTIONS: '/agency/connections',
  AGENCY_ONBOARDING: '/agency/onboarding',
  AGENCY_SETUP: '/agency/setup',
  AGENCY_BILLING: '/agency/billing',
  AGENCY_SETTINGS: '/agency/settings',
  AGENCY_SETTINGS_NOTIFICATIONS: '/agency/settings/notifications',
  AGENCY_SETTINGS_SECURITY: '/agency/settings/security',
  ADMIN: '/admin',
  ADMIN_ORGANIZATIONS: '/admin/organizations',
  ADMIN_ORGANIZATION_DETAIL: '/admin/organizations/$orgId',
  ADMIN_USERS: '/admin/users',
  ADMIN_USER_DETAIL: '/admin/users/$userId',
  ADMIN_INVITATIONS: '/admin/invitations',
  ADMIN_JOBS: '/admin/jobs',
  ADMIN_JOB_DETAIL: '/admin/jobs/$jobId',
  ADMIN_INTEGRATIONS: '/admin/integrations',
  ADMIN_LLM_USAGE: '/admin/llm-usage',
  ADMIN_LLM_USAGE_DETAIL: '/admin/llm-usage/$orgId',
  ADMIN_MANAGED_SPEND: '/admin/managed-spend',
  ADMIN_USER_ANALYTICS: '/admin/user-analytics',
  ADMIN_AI_QUALITY: '/admin/ai-quality',
  ADMIN_SYSTEM: '/admin/system',
  ADMIN_AUDIT: '/admin/audit',
  ADMIN_AUDIT_REPORTS: '/admin/audit-reports',
  ADMIN_AUDIT_REPORT_DETAIL: '/admin/audit-reports/$intakeId',
} as const;

// Uncomment when route-typed props are needed by components.
// export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES];
